<template>
  <div v-if="loadedRules && loadedQuery">
    <vue-query-builder
      :rules="rules"
      :max-depth="10"
      :initial-query="initialTestQuery"
      :show-only="showOnly"
      :program-id="programId"
      @queryUpdated="queryUpdated"
    />

    <!--This value is uploaded when the user in the form that embeds this component presses submit-->
    <input
      type="hidden"
      name="filter"
      :value="filterValue"
    >
  </div>
  <div v-else-if="errors">
    <div
      class="alert alert-primary"
      role="alert"
    >
      {{ trans('filters.errors.server_error') }}
    </div>
  </div>
  <div
    v-else
    style="text-align:center"
  >
    <i class="fa fa-spinner fa-pulse fa-2x fa-fw" />
  </div>
</template>

<script>
import { deepClone, transformFromFilter, transformToFilter } from './VueQueryBuilder/utilities'

import VueQueryBuilder from './VueQueryBuilder/VueQueryBuilder.vue'

import QueryDateTimePicker from './QueryDateTimePicker'
import QueryMagicSuggest from './QueryMagicSuggest'

export default {

  components: {
    VueQueryBuilder,
  },
  props: {
    model: {
      type: String,
      required: true,
    },
    ruleId: {
      required: false,
    },
    maxDepthModel: {
      required: true,
      default: 2,
    },
    showOnly: {
      type: Boolean,
      default: false,
    },
    programId: {
      type: [String, Number],
      required: false,
      default: null,
    },
  },

  data () {
    return {
      query: null,
      loadedQuery: false,
      loadedRules: false,
      initialTestQuery: null,
      rules: [],
      errors: false,

    }
  },

  computed: {
    formattedFilter () {
      return JSON.stringify(transformToFilter(this.query, this.model), null, 2)
    },

    filterValue () {
      return JSON.stringify(transformToFilter(this.query, this.model))
    },
  },
  watch: {

    model: function (newVal, oldVal) {
      if (newVal != oldVal) {
        this.calculateRules()
      }
    },

  },

  mounted () {
    this.getExistingQuery()
    this.calculateRules()

    return this
  },

  methods: {
    queryUpdated (query) {
      this.query = query

      this.$emit('queryUpdated', transformToFilter(query, this.model))
    },

    getExistingQuery () {
      // if we are creating a new query, we don't load an existing query
      if (typeof this.ruleId === 'undefined') {
        this.loadedQuery = true
        this.initialTestQuery = undefined

        return
      }

      axios.get(`/admin/filterrules/filter`, { params: {
        filter_id: this.ruleId,
      } }).then((response) => {
        this.initialTestQuery = transformFromFilter(response.data)
        //          this.initialTestQuery = undefined
        this.loadedQuery = true
      }).catch(error => {
        // since we are trying to edit an existing query, not being able to load the query
        // means we can't continue
        this.errors = true
      })
    },

    calculateRules () {
      let rules = []

      axios.get(`/admin/filterrules/rules`, { params: { model: this.model, max_depth: this.maxDepthModel } }).then((response) => {
        response.data.forEach(function (ruleProp) {
          let rule = {
            id: ruleProp.name,
            operators: ruleProp.operators,
            label: ruleProp.name,
          }

          if ('type' in ruleProp) {
            if (ruleProp.type === 'datetime') {
              rule.type = 'custom-component'
              rule.component = QueryDateTimePicker
            } else if (ruleProp.type === 'suggest') {
              rule.type = 'custom-component'
              rule.component = QueryMagicSuggest
              rule.operators = ['in']
              rule.suggest_type = ruleProp.suggest_type
            }
          } else {
            rule.type = 'text'
          }

          rules.push(rule)
        })

        this.rules = rules
        this.loadedRules = true
      }).catch(error => {
        this.errors = true
      })
    },
  },
}
</script>
